<template lang="pug">
    div
      a.btn.btn-default.ml-2(:class="`btn-${btn_size}`"  @click="onClick") {{image_mode?"画像方式":"HTML方式"}}
      div.d-flex.align-items-center
      ChangeHeatmapMode(v-if="show_modal", @close-modal="show_modal = false" :action_url="action_url" :image_mode="image_mode")
</template>
  
  <script>
  //libs
  import ChangeHeatmapMode from "./modals/change_heatmap_mode.vue";
  
  export default {
    props: {
      image_mode: {type: Boolean, default: true },
      action_url: {type: String, default: "" },
      btn_size: {type: String, default: "sm" },
    },
    methods: {
      onClick(e){
          e.preventDefault()
          this.show_modal = true
          return false
      },
    },
    data(){
      return {
        show_modal: false,
      }
    },
    components: {
      ChangeHeatmapMode,
    },
  }
  </script>